import Component from 'vue-class-component'
import Vue from 'vue'
import { User } from '@/classes/User'
import Api from '@/api'
import { EUserPermissions } from '@zunta/configurations'

@Component
export class ResidentPageMixin extends Vue {
  user: User = Api.getUser() as User
  EUserPermissions: any = EUserPermissions
  innerHeight: number = window.innerHeight

  get isSmallScreenHeight (): boolean {
    return this.innerHeight < 900
  }

  get isMidScreenHeight (): boolean {
    return this.innerHeight >= 900 && this.innerHeight < 1050
  }

  get isBigScreenHeight (): boolean {
    return this.innerHeight >= 1050
  }

  get noRowsUpperContainerHeight (): number {
    return this.isSmallScreenHeight ? 240 : this.isMidScreenHeight ? 275 : 318
  }

  get noRowsBottomContainerHeight (): number {
    return this.isSmallScreenHeight ? 175 : this.isMidScreenHeight ? 255 : 318
  }

  setHeight () {
    this.innerHeight = window.innerHeight
  }

  created () {
    this.setHeight()
    window.addEventListener('resize', this.setHeight)
  }

  destroyed () {
    window.removeEventListener('resize', this.setHeight)
  }
}
